import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../assets/img/close_x.svg'


const _hoisted_1 = { class: "" }
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = { class: "fakelabel-overlay" }
const _hoisted_5 = ["id", "href", "aria-controls"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = ["value", "id"]
const _hoisted_12 = ["for"]
const _hoisted_13 = { class: "col-12 text-md-end ps-0" }
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "position-relative" }
const _hoisted_16 = ["id", "placeholder", "aria-expanded", "aria-activedescendant"]
const _hoisted_17 = ["alt"]
const _hoisted_18 = { class: "visually-hidden alert-primary" }
const _hoisted_19 = {
  key: 0,
  class: "autocomplete",
  id: "autocompleteDropdownList",
  role: "listbox"
}
const _hoisted_20 = ["onClick", "onMouseover", "aria-selected", "id"]
const _hoisted_21 = {
  key: 0,
  class: "additional"
}
const _hoisted_22 = { class: "position-relative fake-label" }
const _hoisted_23 = { class: "checkbox-fakelabel" }
const _hoisted_24 = {
  key: 0,
  class: "fakelabel d-none d-md-block m-0",
  "aria-hidden": "true"
}
const _hoisted_25 = {
  key: 1,
  class: "col-12 mt-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["row", { 'mb-0 mx-0 sucheformularergebnis' : _ctx.type == 'search', 'mb-0' : _ctx.type == 'home' }]),
      id: _ctx.type != 'overlay' ? 'sucheformular' : 'ovform'
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["col-12 mb-2", { 'mb-3' : _ctx.type == 'search' }])
      }, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.messages.headline), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["col-12 mb-3", { 'col-md-4' : _ctx.type != 'search' }])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.messages.inputRight), 1),
          _createElementVNode("a", {
            ref: "topicsCollapse",
            id: 'topics_' + _ctx.type,
            class: "fakedropdown form-control d-flex align-items-center",
            "data-bs-toggle": "collapse",
            href: (_ctx.type == 'search' ? '#collapseCheckboxenErgebnis' : (_ctx.type == 'overlay' ? '#collapseCheckboxen' : (_ctx.type == 'home' ? '#collapseCheckboxenStart' : ''))),
            role: "button",
            "aria-expanded": "false",
            "aria-controls": (_ctx.type == 'search' ? 'collapseCheckboxenErgebnis' : (_ctx.type == 'overlay' ? 'collapseCheckboxen' : (_ctx.type == 'home' ? 'collapseCheckboxenStart' : '')))
          }, [
            _createElementVNode("div", null, [
              (_ctx.selectedTopics.length > 0 && _ctx.topics && _ctx.topics.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedTopics.length) + "/" + _toDisplayString(_ctx.topics.length) + " " + _toDisplayString(_ctx.messages.inputRightChoosen), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.messages.inputRightPlaceholder), 1))
            ]),
            _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"chev-icons ms-auto\" data-v-534806b5><div class=\"chev-down\" data-v-534806b5><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-down\" viewBox=\"0 0 16 16\" aria-hidden=\"true\" data-v-534806b5><path fill-rule=\"evenodd\" d=\"M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z\" data-v-534806b5></path></svg></div><div class=\"chev-up\" data-v-534806b5><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-up\" viewBox=\"0 0 16 16\" aria-hidden=\"true\" data-v-534806b5><path fill-rule=\"evenodd\" d=\"M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z\" data-v-534806b5></path></svg></div></div>", 1))
          ], 8, _hoisted_5),
          _createElementVNode("div", {
            class: "collapse mb-4",
            id: (_ctx.type == 'search' ? 'collapseCheckboxenErgebnis' : (_ctx.type == 'overlay' ? 'collapseCheckboxen' : (_ctx.type == 'home' ? 'collapseCheckboxenStart' : '')))
          }, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topics, (topic, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-12 col-md-6 col-lg-4"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      value: topic.id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTopics) = $event)),
                      id: 'thema_' + index + (_ctx.type != 'overlay' ? '_start' : '')
                    }, null, 8, _hoisted_11), [
                      [_vModelCheckbox, _ctx.selectedTopics]
                    ]),
                    _createElementVNode("label", {
                      class: "form-check-label checkbox-label d-flex align-items-top",
                      for: 'thema_' + index + (_ctx.type != 'overlay' ? '_start' : '')
                    }, [
                      _createElementVNode("span", null, _toDisplayString(topic.description), 1)
                    ], 8, _hoisted_12)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_13, [
                (_ctx.chooseAll)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-link btn-chooseall",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.chooseAllTopics())),
                      rel: "chooseAll"
                    }, _toDisplayString(_ctx.$t("searchlist.chooseAll")), 1))
                  : _createCommentVNode("", true),
                (_ctx.chooseNone)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-link btn-chooseall",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.chooseNoTopics())),
                      rel: "chooseNone"
                    }, _toDisplayString(_ctx.$t("searchlist.chooseNone")), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_8)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["col-12 mb-3", { 'col-md-4' : _ctx.type != 'search' }])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["", (_ctx.type == 'search') ? 'hsearchsite' : ''])
        }, [
          _createElementVNode("label", {
            class: "fakelabel-overlay",
            for: _ctx.type != 'overlay' ? 'sucheOrtStart' : 'sucheOrtOverlay'
          }, _toDisplayString(_ctx.messages.inputLeft), 9, _hoisted_14),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mapRegionToAC && _ctx.mapRegionToAC(...args))),
              onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchAutocomplete && _ctx.searchAutocomplete(...args))),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.chooseAutocompleteData(_ctx.currentHighlightIndex))),
              type: "text",
              class: "form-control custom-search-input w-100",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRegion) = $event)),
              id: _ctx.type != 'overlay' ? 'sucheOrtStart' : 'sucheOrtOverlay',
              placeholder: _ctx.messages.inputLeftPlaceholder,
              autocomplete: "off",
              "aria-autocomplete": "both",
              onKeyup: [
                _cache[7] || (_cache[7] = _withKeys(($event: any) => (_ctx.chooseAutocompleteData(_ctx.currentHighlightIndex)), ["enter"])),
                _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleCloseAutocomplete && _ctx.handleCloseAutocomplete(...args)), ["escape"])),
                _cache[10] || (_cache[10] = _withKeys(_withModifiers(($event: any) => (_ctx.highlightNextAutocompleteData(-1)), ["prevent"]), ["up"])),
                _cache[11] || (_cache[11] = _withKeys(_withModifiers(($event: any) => (_ctx.highlightNextAutocompleteData(1)), ["prevent"]), ["down"]))
              ],
              onFocusout: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleCloseAutocomplete && _ctx.handleCloseAutocomplete(...args))),
              "aria-controls": "autocompleteDropdownList",
              "aria-expanded": _ctx.hideDropdownList? 'false' : 'true',
              "aria-activedescendant": _ctx.highlightAutocompleteId(_ctx.currentHighlightIndex)
            }, null, 40, _hoisted_16), [
              [_vModelText, _ctx.selectedRegion]
            ]),
            (_ctx.selectedRegion && _ctx.selectedRegion.length > 3)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-suche bg-white custom-search-button me-1",
                  role: "button",
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.flushRegionInput()), ["prevent"])),
                  ref: "regionflusButton"
                }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    width: "10",
                    height: "10",
                    alt: _ctx.$t('searchlist.clearIcon'),
                    "aria-hidden": "true"
                  }, null, 8, _hoisted_17),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('searchlist.resetInput')), 1)
                ], 512))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.hideDropdownList && _ctx.autocompleteDataSearch.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autocompleteDataSearch, (acElement, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    onClick: ($event: any) => (_ctx.chooseAutocompleteData(index)),
                    onMouseover: ($event: any) => (_ctx.currentHighlightIndex = index),
                    class: _normalizeClass(_ctx.getListElementCssClass(index)),
                    "aria-selected": _ctx.getListElementAriaSelected(index),
                    role: "option",
                    id: _ctx.highlightAutocompleteId(index)
                  }, [
                    _createTextVNode(_toDisplayString(acElement.value) + " ", 1),
                    (acElement.additionalValue)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(acElement.additionalValue), 1))
                      : _createCommentVNode("", true)
                  ], 42, _hoisted_20))
                }), 128)),
                (_ctx.autocompleteDataSearch === undefined || _ctx.autocompleteDataSearch.length === 0)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleCloseAutocomplete && _ctx.handleCloseAutocomplete(...args)))
                    }, _toDisplayString(_ctx.$t("common.noMoreEntries")), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      (_ctx.type != 'search')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["col-12 mb-3", { 'col-md-2' : _ctx.type != 'search' }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["", (_ctx.type == 'search') ? 'hsearchsite' : ''])
            }, [
              _createElementVNode("label", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "onlineberatung",
                  name: "onlineberatung",
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.withOnlineCounseling) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.withOnlineCounseling]
                ]),
                _createElementVNode("span", _hoisted_23, " " + _toDisplayString(_ctx.$t("searchlist.withonline")), 1),
                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "online-checkbox" }, null, -1))
              ])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["col-12", { 'col-md-2': _ctx.type != 'search' }])
      }, [
        (_ctx.type != 'search')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, " "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          onClick: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
          type: "submit",
          class: "btn btn-primary-custom w-100 mt-12px"
        }, _toDisplayString(_ctx.messages.searchLabel), 1)
      ], 2),
      (_ctx.type == 'search')
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => {_ctx.reset(); _ctx.submit()}, ["prevent"])),
              title: ""
            }, _toDisplayString(_ctx.messages.showAllLabel), 1)
          ]))
        : _createCommentVNode("", true)
    ], 10, _hoisted_2)
  ]))
}